import React, { useMemo } from 'react';
import { useChatStore } from '@modules/chat/store/chatStore';
import { useRequest } from '@common/services/api';
import { useAppSelector } from '@common/hooks';
import { selected } from '@modules/organisation/selectors/organisation';
import Attachment from '@common/components/attachment';
import { EFileTypes } from '@common/definitions';
import { Spinner } from '@common/components/spinner';
import type { Attachment as AttachmentType } from '@common/types/objects';
import { useTranslation } from 'react-i18next';
import Placeholder from '@common/components/placeholder';
import { Button } from '@common/components/button';
import PureList from '@common/components/list';



const DocsList = () => {
  const { t } = useTranslation();
  const orgId = useAppSelector(selected).id;
  const {
    conversationId,
  } = useChatStore();

  const apiConfig = useMemo(() => ({
    useCursor: true,
    limit: 20,
    payload: {
      type: [EFileTypes.DOCUMENT, EFileTypes.PDF, EFileTypes.SPREADSHEET, EFileTypes.PRESENTATION, EFileTypes.AUDIO],
    },
    cachePolicy: 'no-cache',
  }), []);

  const apiUrl = useMemo(() => {
    const baseUrl = `/v3/organisations/${orgId}/conversations/${conversationId}/attachments`;
    return baseUrl;
  }, [orgId, conversationId]);

  const {
    data: docFiles,
    loading,
    meta,
    refetch
  } = useRequest<{ data: AttachmentType[], meta: any }>(apiUrl, apiConfig);

  const pagination = useMemo(() => meta?.pagination, [meta?.pagination]);



  return (
    <div className="tw-grid tw-grid-cols-1 tw-gap-[2%]">
      <PureList<AttachmentType, {}>
        items={docFiles as AttachmentType[]}
        renderRow={({ item }) => {
          return (
            <div key={item.id} className="tw-mb-4">
              <Attachment
                item={item}
                size="small"
                maxHeight={80}
                isOnlyForView
              />
            </div>
          );
        }}
        footer={
          <div className="tw-items-center tw-justify-center">
            {!!pagination?.next_cursor && (
            <Button
              className="tw-text-center tw-font-semibold tw-clear-both tw-border-solid
        tw-border-background tw-w-full tw-relative tw-cursor-pointer
        "
              onClick={refetch}
              isLoading={loading}
            >
              {t('chat:conversations_load_more')}
            </Button>
            )}
          </div>
        }
        placeholder={
          loading ? (
            <Spinner centered />
          ) : (
            <Placeholder title={t('chat:no_docs_found')} />
          )
        }
      />
    </div>
  );
};

export default React.memo(DocsList);
